import HeaderCheckoutView from './header-checkout-view'

export default HeaderCheckoutView
